"use client";
import { useEffect, useState } from "react";
import AboutSkeleton from "../../Skeleton/AboutUs";

export type aboutdata = {
  heading: string;
  imgSrc: string;
  paragraph: string;
};

const Aboutus = () => {
  // fetch about data
  const [about, setAbout] = useState<aboutdata[]>([]);
  const [loading, setLoading] = useState(true);

  const useMockData = true;
  const mockAbout: aboutdata[] = [
    {
      heading: "Instant 3D Mapping",
      imgSrc: "/images/aboutus/imgOne.svg",
      paragraph: "Transform flat 2D designs into realistic 3D can mockups with our high-precision mapping engine.",
    },
    {
      heading: "Immersive Viewport",
      imgSrc: "/images/aboutus/imgTwo.svg",
      paragraph: "Inspect every detail of your brand with 360° rotation and dynamic lighting in a responsive environment.",
    },
    {
      heading: "Seamless Collaboration",
      imgSrc: "/images/aboutus/imgThree.svg",
      paragraph: "Present your vision instantly to clients or retailers via secure, shareable links and custom QR codes.",
    },
  ];

  useEffect(() => {
    if (useMockData) {
      setAbout(mockAbout);
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      try {
        const res = await fetch("/api/data");
        if (!res.ok) throw new Error("Failed to fetch");
        const contentType = res.headers.get("content-type") || "";
        if (!contentType.includes("application/json")) {
          throw new Error("Invalid JSON response");
        }
        const data = await res.json();
        setAbout(data.Aboutdata);
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <section id="About" className="bg-cover bg-center overflow-hidden">
      <div className="container mx-auto max-w-7xl px-4 relative z-1">
        <div className="p-12 bg-grey dark:bg-darkmode rounded-3xl">
          <img
            src="/images/aboutus/dots.svg"
            width={100}
            height={100}
            alt="dots-image"
            className="absolute bottom-1 -left-20"
          />
          <p className="text-center text-primary text-lg tracking-widest uppercase mt-10">
            Core Capabilities
          </p>
          <h2 className="text-center text-4xl md:text-5xl font-extrabold text-black dark:text-white">Engineered for Precision.</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-16 mt-10">
            {loading
              ? Array.from({ length: 3 }).map((_, index) => (
                  <AboutSkeleton key={index} />
                ))
              : about.map((item, i) => (
                  <div
                    key={i}
                    className="hover:bg-accent bg-white dark:bg-slate-900 rounded-3xl p-8 shadow-xl group"
                  >
                    <h5 className="group-hover:text-primary mb-5 dark:text-white">
                      {item.heading}
                    </h5>
                    <img
                      src={item.imgSrc}
                      alt={item.imgSrc}
                      width={100}
                      height={100}
                      className="mb-5"
                    />
                    <p className="text-lg font-normal text-black dark:text-white/70 group-hover:text-foreground mb-5">
                      {item.paragraph}
                    </p>
                  </div>
                ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Aboutus;
